import React, { useState } from 'react';
import { Button, Select } from 'takeat-design-system-ui-kit';
import { format } from 'date-fns';
import { ClosingCashierTableRow, ClosingCashierTableColumn } from '../styles';

const PinpadTotemModalRow = (props) => {
  const {
    transaction,
    confirmPinpadTotemTransaction,
    paymentMethods,
    getStatusTransaction,
  } = props;
  const [paymentMethodId, setPaymentMethodId] = useState(null);
  const [loading, setLoading] = useState(false);

  return (
    <ClosingCashierTableRow style={{ display: 'flex' }} key={transaction.id}>
      <ClosingCashierTableColumn>
        {format(new Date(transaction.created_at), 'dd/MM/yy - HH:mm')}
      </ClosingCashierTableColumn>
      <ClosingCashierTableColumn>
        R$ {transaction.total_price.replace('.', ',')}
      </ClosingCashierTableColumn>
      <ClosingCashierTableColumn>
        {getStatusTransaction(transaction.status)}
      </ClosingCashierTableColumn>
      <ClosingCashierTableColumn
        style={{
          width: 200,
        }}
      >
        {transaction.payments.length > 0 ? (
          <>{transaction.payments[0].payment_method.name}</>
        ) : (
          <>
            {transaction.status === 'waiting_payment' && (
              <Select
                isSearchable
                options={paymentMethods}
                onChange={(e) => {
                  setPaymentMethodId(e.value);
                }}
                containerStyles={{
                  textAlign: 'left',
                  width: 170,
                }}
              />
            )}
          </>
        )}
      </ClosingCashierTableColumn>
      {transaction.status === 'waiting_payment' ? (
        <Button
          disabled={loading}
          isLoading={loading}
          style={{
            width: 80,
            marginRight: 8,
          }}
          onClick={() => {
            confirmPinpadTotemTransaction(
              paymentMethodId,
              transaction.id,
              setLoading
            );
          }}
        >
          Pagar
        </Button>
      ) : (
        <ClosingCashierTableColumn
          style={{
            width: 88,
          }}
        />
      )}
    </ClosingCashierTableRow>
  );
};

export default PinpadTotemModalRow;
